<template>
    <calculation-container>
        <div class="textcontent">
            <h1 class="calculator-titleSmall">Poptávka materiálu - kontaktní údaje</h1>
        </div>
        <calculation-demand-information-form-container @calculation-demand-created="onCreate"></calculation-demand-information-form-container>
        <router-link class="calculator-backLink" :to="{name: 'calculation.contactSelect'}">
            Zpět na výběr dodavatele
        </router-link>
    </calculation-container>
</template>

<script>
import {mapGetters} from 'vuex';
import CalculationContainer from '../CalculationContainer';
import ErrorState from '../../error/ErrorState';
import CalculationDemandInformationFormContainer from './DemandInformationFormContainer';

export default {
    name:       'CalculationDemandInformationContainer',
    components: {
        ErrorState,
        CalculationContainer,
        CalculationDemandInformationFormContainer,
    },
    mounted() {
        if ((null === this.selectedConstructionId && null === this.bimId) || null === this.contactId) {
            this.$router.push({ name: 'calculation.projectSelect' });
        } else {
            this.remarketingDataLayer();
        }
    },
    computed:   {
        ...mapGetters('calculation', ['selectedConstructionId', 'bimId', 'contactId', 'construction', 'selectedProject', 'userInput']),
        ...mapGetters('locator', ['contacts']),
    },
    methods:    {
        onCreate(data) {
            this.createRemarketingDataLayer(data);
            this.$router.push({ name: 'calculation.sent' });
        },
        remarketingDataLayer() {
            const contact = this.contacts.find(({ id }) => this.contactId == id);

            if (contact) {
                const { company: { name, coordinates: { address } } } = contact;
                const contractor = `${name} ${address}`;
                dataLayer.push({
                    'event':      'calculator_step_4',
                    'section':    this.construction.id,
                    'step':       4,
                    'contractor': contractor,
                    'ecommerce':  {
                        'checkout': {
                            'actionField': { 'step': 4, 'option': contractor },
                        }
                    },
                })
            }
        },
        createRemarketingDataLayer({ requestData, response }) {
            const products = requestData.products.map((construction) => {
                return construction.products.map(({ consumption, id, name }) => {
                    return {
                        id, name, quantity: consumption, category: construction.name
                    };
                })
            }).flat();
            dataLayer.push({
                'event':        'calculator',
                'section':      this.construction.id,
                'step':         5,
                'include_work': requestData.demandInformation.withWork,
                'pickup_store': requestData.demandInformation.pickUpAtStore,
                'newsletter':   requestData.demandInformation.mktApproval,
                'area':          this.userInput.meters,
                'waste':         this.userInput.cut,
                'ecommerce':    {
                    'purchase': {
                        'actionField': { 'id': response.id, 'option': 'poptat material' },
                        'products':    products,
                    }
                },
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/calculation/demand/DemandInformationContainer.vue